import axios from 'axios';
import { API_URL } from '../config/api';

export const dgiiApi = {
	// Formularios
	getFormularios: async (params = {}) => {
		const queryParams = new URLSearchParams();
		if (params.empresa) queryParams.append('empresa', params.empresa);
		if (params.usuario) queryParams.append('usuario', params.usuario);
		const url = `${API_URL}/api/dgii/formularios/${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
		const { data } = await axios.get(url);
		return data;
	},
	
	getFormulario: async (id) => {
		const { data } = await axios.get(`${API_URL}/api/dgii/formularios/${id}/`);
		return data;
	},
	
	createFormulario: async (formData) => {
		const { data } = await axios.post(`${API_URL}/api/dgii/formularios/`, formData);
		return data;
	},
	
	updateFormulario: async (id, formData) => {
		const { data } = await axios.put(`${API_URL}/api/dgii/formularios/${id}/`, formData);
		return data;
	},
	
	actualizarRegistro: async (formularioId, registroId, campos, camposBusqueda = null) => {
		const payload = {
			registro_id: registroId,
			campos: campos
		};
		// Enviar campos de búsqueda por contenido como fallback cuando el ID no coincide
		if (camposBusqueda) {
			payload.campos_busqueda = camposBusqueda;
		}
		const { data } = await axios.post(`${API_URL}/api/dgii/formularios/${formularioId}/actualizar_registro/`, payload);
		return data;
	},
	moverRegistroAFormulario: async (formularioId, registroId, nuevoPeriodo, nuevaFecha, camposBusqueda = null) => {
		const payload = {
			registro_id: registroId,
			nuevo_periodo: nuevoPeriodo,
			nueva_fecha: nuevaFecha
		};
		// Enviar campos de búsqueda por contenido como fallback cuando el ID no coincide
		if (camposBusqueda) {
			payload.campos_busqueda = camposBusqueda;
		}
		const { data } = await axios.post(`${API_URL}/api/dgii/formularios/${formularioId}/mover_registro/`, payload);
		return data;
	},
	getFacturasFisicas: async (id) => {
		const { data } = await axios.get(`${API_URL}/api/dgii/formularios/${id}/facturas_fisicas/`);
		return data;
	},
	
	// Facturas Extraídas (físicas)
	getFacturaExtraida: async (id) => {
		const { data } = await axios.get(`${API_URL}/api/dgii/facturas-extraidas/${id}/`);
		return data;
	},
	
	convertirDuplicadoAPrincipal: async (facturaId) => {
		const { data } = await axios.post(`${API_URL}/api/dgii/facturas-extraidas/${facturaId}/convertir_a_principal/`);
		return data;
	},
	
	eliminarDuplicado: async (facturaId) => {
		const { data } = await axios.post(`${API_URL}/api/dgii/facturas-extraidas/${facturaId}/eliminar_duplicado/`);
		return data;
	},
	
	actualizarEstadoFacturaExtraida: async (facturaId, estado, motivo = '') => {
		const { data } = await axios.patch(`${API_URL}/api/dgii/facturas-extraidas/${facturaId}/actualizar_estado/`, {
			estado_analisis: estado,
			motivo_analisis: motivo
		});
		return data;
	},
	
	// Comparación y merge
	compararDuplicadoConPrincipal: async (facturaId) => {
		const { data } = await axios.get(`${API_URL}/api/dgii/facturas-extraidas/${facturaId}/comparar_con_principal/`);
		return data;
	},
	
	mergeDuplicadoConPrincipal: async (facturaId, campos, accionDuplicado = 'cambiar_estado') => {
		const { data } = await axios.post(`${API_URL}/api/dgii/facturas-extraidas/${facturaId}/merge_con_principal/`, {
			campos: campos,
			accion_duplicado: accionDuplicado
		});
		return data;
	},
	
	// Procesamiento en lote
	procesarDuplicadosLote: async (facturaIds, accion, nuevoEstado = null, motivo = '') => {
		const { data } = await axios.post(`${API_URL}/api/dgii/facturas-extraidas/procesar_lote/`, {
			factura_ids: facturaIds,
			accion: accion,
			nuevo_estado: nuevoEstado,
			motivo: motivo
		});
		return data;
	},
	
	// Exportar duplicados
	exportarDuplicados: async (formularioId) => {
		const response = await axios.get(`${API_URL}/api/dgii/facturas-extraidas/exportar_duplicados/?formulario=${formularioId}`, {
			responseType: 'blob'
		});
		return response.data;
	},
	
	deleteFormulario: async (id, payload = {}) => {
		const { data } = await axios.delete(`${API_URL}/api/dgii/formularios/${id}/`, { data: payload });
		return data;
	},
	
	procesarFacturas: async (id) => {
		const { data } = await axios.post(`${API_URL}/api/dgii/formularios/${id}/procesar_facturas/`);
		return data;
	},
	
	exportarXLSX: async (id) => {
		const { data } = await axios.post(`${API_URL}/api/dgii/formularios/${id}/exportar_xlsx/`, {}, {
			responseType: 'blob', // Importante para descargar archivos binarios
		});
		return data;
	},

	/** Exportar formulario 606 a TXT (pipe-delimited). exclude_pendientes=1 para no incluir registros pendientes (header X-Excluded-Pendientes indica cuántos se excluyeron). */
	exportarTXT: async (id, excludePendientes = true) => {
		const response = await axios.get(`${API_URL}/api/dgii/formularios/${id}/exportar_txt/`, {
			responseType: 'blob',
			params: excludePendientes ? { exclude_pendientes: '1' } : {},
		});
		return response;
	},
	
	crearVersion: async (id, notas) => {
		const { data } = await axios.post(`${API_URL}/api/dgii/formularios/${id}/crear_version/`, { notas_cambio: notas });
		return data;
	},
	
	getPreview: async (id) => {
		const { data } = await axios.get(`${API_URL}/api/dgii/formularios/${id}/preview/`);
		return data;
	},
	
	refreshFormulario: async (id) => {
		try {
			const { data } = await axios.get(`${API_URL}/api/dgii/formularios/${id}/refresh/`);
			return data;
		} catch (err) {
			const detail = err?.response?.data?.detail;
			if (detail) console.error('[refreshFormulario] Error del servidor:', detail);
			throw err;
		}
	},

	reconsolidarFormulario: async (id) => {
		const { data } = await axios.post(`${API_URL}/api/dgii/formularios/${id}/reconsolidar/`);
		return data;
	},

	resetCola: async (formularioId = null, opciones = {}) => {
		const payload = formularioId ? { formulario_id: formularioId } : {};
		if (opciones.rescateTodo) payload.rescue_todo = true;
		if (opciones.empresaId) payload.empresa_id = opciones.empresaId;
		const { data } = await axios.post(`${API_URL}/api/dgii/facturas/reset_cola/`, payload);
		return data;
	},

	diagnosticoEmpresa: async (empresaId = null) => {
		const params = empresaId ? `?empresa_id=${empresaId}` : '';
		const { data } = await axios.get(`${API_URL}/api/dgii/facturas/diagnostico_empresa/${params}`);
		return data;
	},
	
	abrirFormulario: async (id, claveAdmin) => {
		const { data } = await axios.post(`${API_URL}/api/dgii/formularios/${id}/abrir_formulario/`, {
			clave_admin: claveAdmin
		});
		return data;
	},
	
	cerrarFormulario: async (id) => {
		const { data } = await axios.post(`${API_URL}/api/dgii/formularios/${id}/cerrar_formulario/`);
		return data;
	},
	
	procesarPendientes: async (tipoFormulario = '606', tipoCarga = null, empresaId = null) => {
		const payload = {
			tipo_formulario: tipoFormulario
		};
		if (tipoCarga) {
			payload.tipo_carga = tipoCarga;
		}
		if (empresaId) {
			payload.empresa_id = empresaId;
		}
		const { data} = await axios.post(`${API_URL}/api/dgii/facturas/procesar_pendientes/`, payload);
		return data;
	},
	
	reprocesarArchivo: async (archivoId, tipoFormulario = '606') => {
		const { data } = await axios.post(`${API_URL}/api/dgii/facturas/${archivoId}/reprocesar/`, {
			tipo_formulario: tipoFormulario
		});
		return data;
	},
	
	getArchivosAdjuntos: async (params = {}) => {
		const queryParams = new URLSearchParams(params);
		const { data } = await axios.get(`${API_URL}/api/dgii/facturas/?${queryParams.toString()}`);
		return data;
	},
	
	// Facturas
	getFacturas: async () => {
		const { data } = await axios.get(`${API_URL}/api/dgii/facturas/`);
		return data;
	},
	
	getFactura: async (id) => {
		const { data } = await axios.get(`${API_URL}/api/dgii/facturas/${id}/`);
		return data;
	},
	
	uploadFactura: async (formularioId, fileOrFormData) => {
		// Si ya es FormData, usarlo directamente; si no, crear uno nuevo
		const formData = fileOrFormData instanceof FormData 
			? fileOrFormData 
			: (() => {
				const fd = new FormData();
				if (fileOrFormData instanceof File) {
					fd.append('archivo', fileOrFormData);
					fd.append('nombre_original', fileOrFormData.name);
				}
				// Solo agregar formulario si se proporciona
				if (formularioId) {
					fd.append('formulario', formularioId);
				}
				return fd;
			})();
		
		// Si no es FormData y se proporciona formularioId, agregarlo
		if (!(fileOrFormData instanceof FormData) && formularioId) {
			formData.append('formulario', formularioId);
		}
		
		const { data } = await axios.post(`${API_URL}/api/dgii/facturas/`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
		return data;
	},
	
	procesarOCR: async (id) => {
		const { data } = await axios.post(`${API_URL}/api/dgii/facturas/${id}/procesar_ocr/`);
		return data;
	},
	
	deleteFactura: async (id) => {
		const { data } = await axios.delete(`${API_URL}/api/dgii/facturas/${id}/`);
		return data;
	},
	
	// Alertas de API
	getAlertas: async (tipo = null) => {
		const url = tipo 
			? `${API_URL}/api/dgii/alertas/?tipo=${tipo}`
			: `${API_URL}/api/dgii/alertas/`;
		const { data } = await axios.get(url);
		return data;
	},
	
	getResumenAlertas: async () => {
		const { data } = await axios.get(`${API_URL}/api/dgii/alertas/resumen/`);
		return data;
	},
	
	resolverAlerta: async (id) => {
		const { data } = await axios.post(`${API_URL}/api/dgii/alertas/${id}/resolver/`);
		return data;
	},
	
	// Empresas
	getEmpresas: async () => {
		const { data } = await axios.get(`${API_URL}/api/dgii/empresas/`);
		// Manejar respuesta paginada o array directo
		return Array.isArray(data) ? data : (data.results || []);
	},
	
	getEmpresa: async (id) => {
		const { data } = await axios.get(`${API_URL}/api/dgii/empresas/${id}/`);
		return data;
	},
	
	createEmpresa: async (empresaData) => {
		const { data } = await axios.post(`${API_URL}/api/dgii/empresas/`, empresaData);
		return data;
	},
	
	updateEmpresa: async (id, empresaData) => {
		const { data } = await axios.put(`${API_URL}/api/dgii/empresas/${id}/`, empresaData);
		return data;
	},
	
	deleteEmpresa: async (id) => {
		const { data } = await axios.delete(`${API_URL}/api/dgii/empresas/${id}/`);
		return data;
	},
	
	setEmpresaDefault: async (id) => {
		const { data } = await axios.post(`${API_URL}/api/dgii/empresas/${id}/set_default/`);
		return data;
	},
	
	toggleEmpresaFavorite: async (id) => {
		const { data } = await axios.post(`${API_URL}/api/dgii/empresas/${id}/toggle_favorite/`);
		return data;
	},
	
	crearEmpresaDesdePerfil: async () => {
		const { data } = await axios.post(`${API_URL}/api/dgii/empresas/crear_desde_perfil/`);
		return data;
	},
	
	reasignarEmpresa: async (empresaId, nuevoUsuarioId) => {
		const { data } = await axios.post(`${API_URL}/api/dgii/empresas/${empresaId}/reasignar_usuario/`, {
			nuevo_usuario_id: nuevoUsuarioId
		});
		return data;
	},

	// Accesos compartidos de empresa a clientes
	getEmpresaAccesos: async (empresaId) => {
		const { data } = await axios.get(`${API_URL}/api/dgii/empresas/${empresaId}/accesos/`);
		return data;
	},
	otorgarAccesoEmpresa: async (empresaId, usuarioId) => {
		const { data } = await axios.post(`${API_URL}/api/dgii/empresas/${empresaId}/accesos/`, { usuario_id: usuarioId });
		return data;
	},
	revocarAccesoEmpresa: async (empresaId, usuarioId) => {
		const { data } = await axios.delete(`${API_URL}/api/dgii/empresas/${empresaId}/accesos/`, { data: { usuario_id: usuarioId } });
		return data;
	},
	
	// Actividades Económicas
	getActividadesEconomicas: async (search = '', grupo = '') => {
		const params = new URLSearchParams();
		if (search) params.append('search', search);
		if (grupo) params.append('grupo', grupo);
		const { data } = await axios.get(`${API_URL}/api/dgii/actividades-economicas/?${params.toString()}`);
		// Manejar respuesta paginada o array directo
		return Array.isArray(data) ? data : (data.results || []);
	},
	
	getGruposEconomicos: async () => {
		const { data } = await axios.get(`${API_URL}/api/dgii/actividades-economicas/grupos/`);
		return Array.isArray(data) ? data : [];
	},
	createActividadEconomica: async (actividadData) => {
		const token = localStorage.getItem('authToken');
		const { data } = await axios.post(
			`${API_URL}/api/dgii/actividades-economicas/`,
			actividadData,
			{ headers: { Authorization: `Token ${token}` } }
		);
		return data;
	},
	updateActividadEconomica: async (id, actividadData) => {
		const token = localStorage.getItem('authToken');
		const { data } = await axios.put(
			`${API_URL}/api/dgii/actividades-economicas/${id}/`,
			actividadData,
			{ headers: { Authorization: `Token ${token}` } }
		);
		return data;
	},
	deleteActividadEconomica: async (id) => {
		const token = localStorage.getItem('authToken');
		const { data } = await axios.delete(
			`${API_URL}/api/dgii/actividades-economicas/${id}/`,
			{ headers: { Authorization: `Token ${token}` } }
		);
		return data;
	},
	
	// Facturas Editadas (Nueva estructura para histórico)
	getFacturasEditadas: async (formularioId, soloActuales = true) => {
		const params = new URLSearchParams();
		params.append('formulario_id', formularioId);
		if (soloActuales) {
			params.append('solo_actuales', 'true');
		}
		const { data } = await axios.get(`${API_URL}/api/dgii/facturas-editadas/?${params.toString()}`);
		return Array.isArray(data) ? data : (data.results || []);
	},
	
	getHistorialFactura: async (facturaEditadaId) => {
		const { data } = await axios.get(`${API_URL}/api/dgii/facturas-editadas/${facturaEditadaId}/historial/`);
		return data;
	},
	
	crearVersionFactura: async (facturaEditadaId, datosEditados, auditado = false, notasEdicion = '') => {
		const { data } = await axios.post(`${API_URL}/api/dgii/facturas-editadas/${facturaEditadaId}/crear_version/`, {
			datos_editados: datosEditados,
			auditado: auditado,
			notas_edicion: notasEdicion
		});
		return data;
	},
	
	updateFacturaEditada: async (id, facturaEditadaData) => {
		const { data } = await axios.put(`${API_URL}/api/dgii/facturas-editadas/${id}/`, facturaEditadaData);
		return data;
	},
	
	createFacturaEditada: async (facturaEditadaData) => {
		const { data } = await axios.post(`${API_URL}/api/dgii/facturas-editadas/`, facturaEditadaData);
		return data;
	},
	
	// =========================
	// IR-17 Formularios
	// =========================
	
	getFormulariosIR17: async (params = {}) => {
		const queryParams = new URLSearchParams();
		if (params.empresa) queryParams.append('empresa', params.empresa);
		if (params.usuario) queryParams.append('usuario', params.usuario);
		if (params.periodo) queryParams.append('periodo', params.periodo);
		const url = `${API_URL}/api/dgii/formularios-ir17/${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
		const { data } = await axios.get(url);
		return data;
	},
	
	getFormularioIR17: async (id) => {
		const { data } = await axios.get(`${API_URL}/api/dgii/formularios-ir17/${id}/`);
		return data;
	},
	
	createFormularioIR17: async (formData) => {
		const { data } = await axios.post(`${API_URL}/api/dgii/formularios-ir17/`, formData);
		return data;
	},
	
	updateFormularioIR17: async (id, formData) => {
		const { data } = await axios.put(`${API_URL}/api/dgii/formularios-ir17/${id}/`, formData);
		return data;
	},
	
	deleteFormularioIR17: async (id) => {
		const { data } = await axios.delete(`${API_URL}/api/dgii/formularios-ir17/${id}/`);
		return data;
	},
	
	generarIR17Desde606: async (formulario606Id) => {
		const { data } = await axios.post(`${API_URL}/api/dgii/formularios/${formulario606Id}/generar_desde_606/`);
		return data;
	},
	
	calcularTotalesIR17: async (id) => {
		const { data } = await axios.post(`${API_URL}/api/dgii/formularios-ir17/${id}/calcular_totales/`);
		return data;
	},
	
	exportarIR17Excel: async (id) => {
		const response = await axios.get(`${API_URL}/api/dgii/formularios-ir17/${id}/exportar_xlsx/`, {
			responseType: 'blob'
		});
		return response.data;
	},
	
	exportarIR17TXT: async (id) => {
		const response = await axios.get(`${API_URL}/api/dgii/formularios-ir17/${id}/exportar_txt/`, {
			responseType: 'blob'
		});
		return response.data;
	},
	
	// =========================
	// IR-17 Registros
	// =========================
	
	getRegistrosIR17: async (params = {}) => {
		const queryParams = new URLSearchParams();
		if (params.formulario) queryParams.append('formulario', params.formulario);
		if (params.tipo) queryParams.append('tipo', params.tipo);
		const url = `${API_URL}/api/dgii/registros-ir17/${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
		const { data } = await axios.get(url);
		return data;
	},
	
	getRegistroIR17: async (id) => {
		const { data } = await axios.get(`${API_URL}/api/dgii/registros-ir17/${id}/`);
		return data;
	},
	
	createRegistroIR17: async (registroData) => {
		const { data } = await axios.post(`${API_URL}/api/dgii/registros-ir17/`, registroData);
		return data;
	},
	
	updateRegistroIR17: async (id, registroData) => {
		const { data } = await axios.put(`${API_URL}/api/dgii/registros-ir17/${id}/`, registroData);
		return data;
	},
	
	deleteRegistroIR17: async (id) => {
		const { data } = await axios.delete(`${API_URL}/api/dgii/registros-ir17/${id}/`);
		return data;
	},
	
	// =========================
	// Gestión de Colas
	// =========================
	
	getEstadoCola: async (timestampInicio = null) => {
		const url = timestampInicio 
			? `${API_URL}/api/dgii/facturas/estado_cola/?timestamp_inicio=${timestampInicio}`
			: `${API_URL}/api/dgii/facturas/estado_cola/`;
		const { data } = await axios.get(url);
		return data;
	},
	
	getEstadoTarea: async (archivoId) => {
		const { data } = await axios.get(`${API_URL}/api/dgii/facturas/${archivoId}/estado_tarea/`);
		return data;
	},

	// =========================
	// Facturas Manuales
	// =========================

	crearRegistroManual: async (formularioId, datosIniciales = {}) => {
		const { data } = await axios.post(
			`${API_URL}/api/dgii/formularios/${formularioId}/crear_registro_manual/`,
			{ datos: datosIniciales }
		);
		return data;
	},

	actualizarFacturaManual: async (facturaManualId, payload) => {
		const { data } = await axios.patch(
			`${API_URL}/api/dgii/facturas-manuales/${facturaManualId}/`,
			payload
		);
		return data;
	},

	eliminarFacturaManual: async (facturaManualId) => {
		const { data } = await axios.delete(
			`${API_URL}/api/dgii/facturas-manuales/${facturaManualId}/`
		);
		return data;
	},

	getFacturasManuales: async (formularioId) => {
		const { data } = await axios.get(
			`${API_URL}/api/dgii/facturas-manuales/?formulario=${formularioId}`
		);
		return data;
	},
};

